import React, { useRef, ReactElement } from 'react';
import { render as reactRender, unmountComponentAtNode } from 'react-dom';
import cx from 'classnames';
import { useLockScroll } from 'lib/hooks/useLockScroll';
import Portal from './Portal';
import './modal.scss';

interface ModalProps {
  children: ReactElement;
  visible: boolean;
  onBottom: boolean;
  customStyle?: Record<string, any>;
}

const Modal = ({ children, visible, onBottom, customStyle }: ModalProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useLockScroll(ref, visible);

  if (!visible) return null;
  return (
    <Portal wrapperId="modal-portal">
      <div
        className={cx({
          'modal-wrapper': true,
          'modal-wrapper--bottom': onBottom,
        })}
        style={customStyle ? customStyle : {}}
      >
        <div className="modal-wrapper__mask"></div>
        <div className="modal-wrapper__content" ref={ref}>
          {children}
        </div>
      </div>
    </Portal>
  );
};
const container = document.createDocumentFragment();
export function showModal(Component, props = { onBottom: false }) {
  const { onBottom } = props;
  function render(Component) {
    reactRender(
      <Modal visible={true} onBottom={onBottom}>
        {React.cloneElement(Component)}
      </Modal>,
      container,
    );
  }
  render(Component);
}

// 展示独立弹窗，不受其他弹窗关闭的影响
export function showIndependentModal(Component, props = { onBottom: false }) {
  const { onBottom } = props;
  const independentContainer = document.createDocumentFragment();

  function render(Component) {
    reactRender(
      <Modal visible={true} onBottom={onBottom} customStyle={{ zIndex: 1000 }}>
        {React.cloneElement(Component, { closeModal: () => unmountComponentAtNode(independentContainer) })}
      </Modal>,
      independentContainer,
    );
  }
  render(Component);
}

export function closeModal() {
  unmountComponentAtNode(container);
}
